module.exports = __webpack_public_path__ + "img/college3.d5afc641.png";